import { Trans, useTranslation } from "react-i18next";
import Modal from "~/common/components/Modal";
import { Button } from "~/common/components/Button/Button";
import { CART_PAGE } from "~/utils/url/staticUrls";
import { Stacker } from "~/common/components/Stacker/Stacker";

interface Props {
  onClose: () => void;
}

export const SoldOutCampaignModal = ({ onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      onClose={onClose}
      footerChildren={
        <Stacker gap={8} direction="row">
          <Button variant={"text"} onClick={onClose}>
            {t("cancel")}
          </Button>
          <Button href={CART_PAGE}>{t("feature.salesCampaign.cannotQuote.backToCart")}</Button>
        </Stacker>
      }
    >
      <Stacker gap={8}>
        <p className={"f-bold"}>
          <Trans i18nKey={"feature.salesCampaign.soldOut.partOne"} />
        </p>
        <p>
          <Trans i18nKey={"feature.salesCampaign.soldOut.partTwo"} />
        </p>
      </Stacker>
    </Modal>
  );
};
